import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type OptionalId = Branded<string, "OptionalId">;
const optionalIdPrefix = "optional__";
const {
    factory: optionalIdFactory,
    assert: isOptionalId,
    zodSchema: optionalIdZodSchema,
} = genericId<OptionalId>(optionalIdPrefix, {
    // don't match `optional_group_`
    regexMatch: /(?=^optional_)(?=(?!optional_group_))\S+$/,
});

export {
    isOptionalId,
    optionalIdFactory,
    optionalIdPrefix,
    optionalIdZodSchema,
};
export type { OptionalId };
